import type { AlpineComponent } from 'alpinejs'
import { validFormError } from '~/utils/form_errors'

export type UJSResponseData = Document | string | string[] | { message: string } | { error: string }
export type UJSResponse = CustomEvent<[UJSResponseData, string, XMLHttpRequest]>
export type CustomUJSResponse<T> = CustomEvent<[T, string, XMLHttpRequest]>

// Success messages can be sent as { message: string }
const isMessageObject = (data: UJSResponseData): data is { message: string } =>
  typeof data === 'object' && Object.keys(data).includes('message')

// Devise sends JSON error responses as { error: string }
const isErrorObject = (data: UJSResponseData): data is { error: string } =>
  typeof data === 'object' && Object.keys(data).includes('error')

// Simple component for basic modal (remote) forms that don't need any fancy submit logic
// To make the form submissions remote, use "form_with" and "local: false" OR "form_for" and "remote: true"
// Successful form submission reloads the page by default, errors get rendered at the top of the form without reloading
export default (reload = true, followRedirectPath = false): AlpineComponent<unknown> => ({
  init() {
    const form = this.$root

    form.addEventListener('ajax:success', (event) => {
      const data = (event as UJSResponse).detail[0]

      if (reload) {
        // By default, the page is refreshed, but if the server responds with a URL
        // (such as the URL of a newly created resource), that can also be followed
        followRedirectPath && typeof data === 'string' ? window.location.assign(data) : window.location.reload()
      } else if (isMessageObject(data)) {
        const { message } = data
        message.length && window.flash('notice', message)
      }
    })

    form.addEventListener('ajax:error', (event) => {
      let data = (event as UJSResponse).detail[0]

      if (isErrorObject(data)) {
        data = [data.error]
      }

      const errors = validFormError(data) ? data : null
      window.renderFormErrors(errors, form)
    })
  },
})
